import { createEntityFilesBlock } from "../entity/createEntityFilesBlock.jsx";
import { sanitizeFileUrl } from "../../utils/filePreview.js";
import { buildObjektInlineFiles } from "../../utils/entityInlineFilePresets.js";

const OBJEKT_TYPEN = ["Plan", "Offerte", "Rechnung", "Bestellung", "Protokoll", "Rapport", "E-Mail", "Foto", "Skizze", "Sonstiges"];

function pickSafeUrl(...candidates) {
  for (const candidate of candidates) {
    const safe = sanitizeFileUrl(candidate || "");
    if (safe) return safe;
  }
  return "";
}

const ObjektEntityFilesBlock = createEntityFilesBlock({
  title: "📁 Objektdokumente",
  compact: true,
  defaultTypes: OBJEKT_TYPEN,
  getApiBase: () => null,
  getApiPaths: (objektId) => ({
    list: `/objekte/${objektId}/uploads`,
    create: `/objekte/${objektId}/upload`,
    remove: (id) => `/objekte/upload/${id}`,
  }),
  parseItems: (data) => {
    const rows = Array.isArray(data) ? data : data?.rows || data?.items || data?.uploads || [];
    return rows;
  },
  resolveFileUrl: (row) => pickSafeUrl(
    row?.secure_preview_url,
    row?.secure_download_url,
    row?.secure_url
  ),
  fileActionMode: "minimal",
  fileActionCompact: true,
  previewModule: "object_files",
});

export default function ObjektBlockDateien({ objektId }) {
  const scrollId = buildObjektInlineFiles(objektId)?.scrollTargetId;
  return (
    <div id={scrollId || undefined} className={scrollId ? "scroll-mt-24" : undefined}>
      <ObjektEntityFilesBlock entityId={objektId} />
    </div>
  );
}
